import { Layout } from "@/components/layout/Layout";
import { HeroSection } from "@/components/home/HeroSection";
import { TrustStrip } from "@/components/home/TrustStrip";
import { WhatWeDo } from "@/components/home/WhatWeDo";
import { WhyMithraJobs } from "@/components/home/WhyMithraJobs";
import { HowItWorks } from "@/components/home/HowItWorks";
import { WhoWeServe } from "@/components/home/WhoWeServe";
import { EditorialMarquee } from "@/components/shared/EditorialMarquee";
import { ClientsPreview } from "@/components/home/ClientsPreview";
import { TeacherCTA } from "@/components/home/TeacherCTA";
import { FinalCTA } from "@/components/home/FinalCTA";

const MARQUEE_ITEMS = [
  "Teacher Recruitment",
  "School Staffing Solutions",
  "Candidate Screening",
  "Recruitment Support",
  "Established 2011",
];

export default function Home() {
  return (
    <Layout
      title="Mithra Jobs | Teacher Recruitment for Schools"
      description="Mithra Jobs helps schools connect with suitable teaching professionals through specialist teacher recruitment and staffing support. Established in 2011."
    >
      <HeroSection />
      <TrustStrip />
      <WhatWeDo />
      <WhyMithraJobs />
      <HowItWorks />
      <WhoWeServe />
      <EditorialMarquee items={MARQUEE_ITEMS} />
      <ClientsPreview />
      <TeacherCTA />
      <FinalCTA />
    </Layout>
  );
}
